<template>
  <custom-dialog :title="$t('change_pwd_dialog.xiu_gai_mi_ma')" append-to-body width="500px" :showClose="model.type !== 'window'" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <p v-if="model.type === 'window'" style="font-size: 13px; margin: -24px 0 12px; color: #0d9ae0">{{ $t('change_pwd_dialog.ndmmyyglyzdlbxcxszmm') }}</p>
      <el-form :model="form" :rules="rules" :validate-on-rule-change="false" ref="pwdform">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('change_pwd_dialog.yuan_mi_ma')" prop="originalPwd">
              <el-input v-model="form.originalPwd" type="password"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="margin-bottom: 20px; font-size: 12px; color: #4d4d4d">{{ $t('change_pwd_dialog.mmcdw816wbszfhzmrylz') }}</p>
            <el-form-item :label="$t('change_pwd_dialog.xin_mi_ma')" prop="newPwd">
              <el-input v-model="form.newPwd" type="password" :placeholder="$t('change_pwd_dialog.qsrxmm')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('change_pwd_dialog.xin_mi_ma_que_ren')" prop="confirmPwd">
              <el-input v-model="form.confirmPwd" type="password" :placeholder="$t('change_pwd_dialog.qzcsrxmm')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="model.type !== 'window'" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" @click="changePwd">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import Cookies from 'js-cookie';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      appName: '',
      parentName: '',
      form: {
        originalPwd: '',
        newPwd: '',
        confirmPwd: '',
      },
      langKeyId: '',
      // 所选分组list
      treeOptionList: [],
    };
  },
  computed: {
    rules() {
      return {
        originalPwd: {
          required: true,
          message: this.$t('change_pwd_dialog.jiu_mi_ma_bi_tian'),
        },
        newPwd: {
          required: true,
          validator: (rule, value, callback) => {
            const reg = /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/;
            if (!value) {
              callback(new Error(this.$t('change_pwd_dialog.xin_mi_ma_bi_tian')));
            } else if (value.toString().length < 8 || value.toString().length > 16) {
              callback(new Error(this.$t('change_pwd_dialog.mmcdbxw816w')));
            } else if (!reg.test(value.toString())) {
              callback(new Error(this.$t('change_pwd_dialog.bxbhszfhzmrylz')));
            } else if (value === this.form.originalPwd) {
              callback(new Error(this.$t('change_pwd_dialog.xmmyjmmbnxt')));
            } else {
              callback();
            }
          },
          trigger: 'blur',
        },
        confirmPwd: {
          required: true,
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error(this.$t('change_pwd_dialog.qrmmbt')));
            } else if (value !== this.form.newPwd) {
              callback(new Error(this.$t('change_pwd_dialog.xmmyqdmmbyz')));
            } else {
              callback();
            }
          },
          trigger: 'blur',
        },
      };
    },
  },
  mounted() {},
  methods: {
    // 修改登录密码
    changePwd: function () {
      this.$refs.pwdform.validate((valid) => {
        if (!valid) {
          console.error(valid);
          return;
        }
        this.$postJSON(
          apis.UpdatePwd,
          {
            originalPwd: this.encrypt(this.form.originalPwd),
            newPwd: this.encrypt(this.form.newPwd),
            confirmPwd: this.encrypt(this.form.confirmPwd),
          },
          true
        )
          .then(() => {
            this.visible = false;
            this.$store.commit('PSWDLOGINCHANGE', '0');
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            Cookies.remove('loginName', { path: '/' });
            Cookies.remove('token', { path: '/' });
            Cookies.remove('tokenTimeOut', { path: '/' });
            Cookies.remove('nonMetric', { path: '/' });
            Cookies.remove('langCode', { path: '/' });
            this.$router.replace({ path: '/login', query: {} });
          })
          .catch(() => {});
      });
    },
  },
};
</script>

<style lang="scss"></style>
